import api, { fileUrl } from "./api";
import { getAuxInput } from "./voiceEnhancer";

/**
 * AI Announcer bus — plays a clip locally AND into the host's outgoing stream
 * (via the voiceEnhancer aux input) so viewers hear it too.
 */
let current = null;

export async function playAnnouncement(url, { intoStream = true, volume = 1.0 } = {}) {
  stopAnnouncement();
  const { ctx, input } = getAuxInput();
  if (ctx.state === "suspended") await ctx.resume().catch(() => {});
  const res = await fetch(fileUrl(url), { credentials: "include" });
  const buf = await ctx.decodeAudioData(await res.arrayBuffer());
  const src = ctx.createBufferSource();
  src.buffer = buf;
  const gain = ctx.createGain();
  gain.gain.value = volume;
  src.connect(gain);
  gain.connect(ctx.destination);
  if (intoStream) gain.connect(input);
  src.start();
  current = src;
  return new Promise((resolve) => { src.onended = () => { if (current === src) current = null; resolve(); }; });
}

export function stopAnnouncement() {
  try { current?.stop(); } catch { /* ignore */ }
  current = null;
}

export const AUTO_ANNOUNCE_KEY = "gw_auto_announce_battles";
export const ANNOUNCER_VOICE_KEY = "gw_announcer_voice";

/** Generate + play a preset announcement (used by the panel and auto-announce). */
export async function announce(presetId, fields = {}, sessionId = null) {
  const voice_id = localStorage.getItem(ANNOUNCER_VOICE_KEY) || "pNInz6obpgDQGcFmaJgB";
  const { data } = await api.post("/ai/voice/announcer", { preset_id: presetId, fields, voice_id, session_id: sessionId });
  await playAnnouncement(data.url);
  return data;
}
